import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ProductsList } from '@icc/b2b/shared';
import { firstValueFrom } from 'rxjs';
import { ConfigService } from '@icc/shared';

@Injectable({ providedIn: 'root' })
export class OwnProductsService {
    products: ProductsList = [];
    loaded = false;

    constructor(private http: HttpClient, private configService: ConfigService) {}

    public async loadOwnProducts(): Promise<ProductsList> {
        const ownProducts = await firstValueFrom(
            await this.http.get<ProductsList>(`${window.location.origin}/api/b2b/products/own?lang=${this.configService.config.languageCode}&marketId=${this.configService.user?.user?.ActiveMarket}`)
        );
        this.products = ownProducts;
        this.loaded = true;
        return this.products;
    }

    public async getOwnProducts(): Promise<ProductsList> {
        if (!this.loaded) {
            return await this.loadOwnProducts();
        }
        return this.products;
    }
}
